var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 86,
    viewBox: "0 0 91 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#BEFFEC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13252_4995)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13252_4995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8998 84.9V17.1002H1.1V84.9H68.8998Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13252_4995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4748 34.5767H62.26C64.3969 34.5767 66.1291 36.3089 66.1291 38.4445V76.3086H3.85938V38.4445C3.85938 36.3089 5.5916 34.5767 7.72851 34.5767H12.5136",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0611 71.5234H8.64844V39.3618H19.884",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1138 39.3618H61.3493V71.5234H18.1641",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6793 80.2578H31.3095C29.1925 80.2578 27.4766 78.5417 27.4766 76.4249V76.3091H42.5122V76.4249C42.5122 78.5417 40.7961 80.2578 38.6793 80.2578Z",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9725 76.3096H1.02344V78.5823C1.02344 81.6887 3.54165 84.207 6.64817 84.207H63.3476C66.4541 84.207 68.9725 81.6887 68.9725 78.5823V76.3096Z",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1112 38.4805V44.2564C50.1112 47.7068 48.0508 50.8379 44.8647 52.1623C38.5558 54.7844 31.4382 54.7844 25.1295 52.1623C21.9433 50.8379 19.8828 47.7068 19.8828 44.2564V38.4805",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1608 21.878L57.5688 28.9805C59.7946 30.1604 59.7946 33.35 57.5688 34.5299L37.7405 45.034C36.8955 45.4811 35.954 45.7148 34.998 45.7148C34.042 45.7148 33.1004 45.4811 32.2554 45.034L12.4271 34.5299C10.2014 33.35 10.2014 30.1604 12.4271 28.9805L32.2554 18.4765C33.1004 18.0293 34.042 17.7956 34.998 17.7956C35.954 17.7956 36.8955 18.0293 37.7405 18.4765L40.5788 19.9804",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 31.7569L43.8205 41.8153V55.4453",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8201 55.4428L41.595 59.2966C40.7922 60.6874 41.7957 62.4258 43.4016 62.4258H44.2386C45.8444 62.4258 46.848 60.6874 46.0451 59.2966L43.8201 55.4428Z",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7578 66.7383H34.2855",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7578 62.4258H27.483",
    stroke: "#49B896",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13252_4995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.8423bbb5b2c271d7c3cf3b62a900c7d2.svg";
export { ForwardRef as ReactComponent };